import { UserPermissions } from "@doitintl/cmp-models";
import { Box, Divider, Paper } from "@mui/material";

import { useAuthContext } from "../../../Context/AuthContext";
import { useUserContext } from "../../../Context/UserContext";
import { Threads } from "../../Threads/Threads";
import { type Insight, type InsightCloudFlows } from "../types";
import { ContactSupport } from "./ContactSupport";
import { InsightStatus } from "./InsightStatus";
import { CloudFlow } from "./SideBar/CloudFlow";

type Props = {
  insight: Insight;
  newSupportTicketUrl: string;
  totalSavings: string;
  cloudFlows: InsightCloudFlows[];
};

export const GetStarted: React.FC<Props> = ({ insight, newSupportTicketUrl, totalSavings, cloudFlows }) => {
  const { userRoles } = useUserContext({ requiredRoles: true });
  const { isDoitEmployee } = useAuthContext();

  const hasThreadsManagerPermission = isDoitEmployee || userRoles.permissions.has(UserPermissions.ThreadsManager);
  const hasCloudFlowManagerPermission = isDoitEmployee || userRoles.permissions.has(UserPermissions.CloudFlowManager);
  const insightSupportsCloudFlow = !!insight.cloudFlowBlueprintId && insight.cloudFlowParams?.length > 0;

  return (
    <Paper elevation={2} sx={{ maxWidth: "312px", position: "sticky", top: 149 }}>
      <Box sx={{ p: 3 }}>
        <InsightStatus />
        <Divider sx={{ my: 2 }} />
        <ContactSupport newSupportTicketUrl={newSupportTicketUrl} insight={insight} totalSavings={totalSavings} />
        {hasThreadsManagerPermission && (
          <>
            <Divider sx={{ my: 2 }} />
            <Threads insight={insight} />
          </>
        )}
        {hasCloudFlowManagerPermission && insightSupportsCloudFlow && (
          <>
            <Divider sx={{ my: 2 }} />
            <CloudFlow
              insightKey={insight.key}
              insightBlueprintId={insight.cloudFlowBlueprintId}
              cloudFlows={cloudFlows}
            />
          </>
        )}
      </Box>
    </Paper>
  );
};
